import { Colors } from '../consts/Colors.js';
let scaleX = 0.82;
let scaleY = 0.593;

export const TextContents = {
    textTitle: {
        text: 'textTitle',
        config: {
            size: `${66 * scaleX}px`,
            fontFamily:
                'MontserratBold, "NotoSansJP-Bold", "NotoSansArabic-Bold", "NotoSansThai-Bold", sans-serif',
            align: 'center',
            color: Colors.Text.DarkBlue,
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 680,
        },
    },
    btnStart: {
        text: 'btnStart',
        config: {
            size: '30px',
            fontFamily: 'DMSans, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: 'Colors.Text.White',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 1920,
        },
    },
    btnEnd: {
        text: 'btnEnd',
        config: {
            size: '30px',
            fontFamily:
                'DMSansBold, "NotoSansJP-Bold", "NotoSansArabic-Bold", "NotoSansThai-Bold", sans-serif',
            align: 'center',
            color: 'Black',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 1920,
        },
    },
    // Tuto
    btnTuto: {
        text: 'btnTuto',
    },
    btnSkip: {
        text: 'btnSkip',
    },
    textTuto1: {
        text: 'textTuto1',
        config: {
            size: '24px',
            fontFamily: 'Montserrat, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: Colors.Text.DarkBlue,
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 670 * scaleX,
        },
    },
    textTuto2: {
        text: 'textTuto2',
        config: {
            size: '12px',
            fontFamily: 'Montserrat, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: 'Black',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 660 * 0.44,
            wordWrap: { width: 850 * scaleX - 80 * scaleX, useAdvancedWrap: true },
        },
    },
    textTuto3: {
        text: 'textTuto3',
        config: {
            size: '12px',
            fontFamily: 'Montserrat, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: 'Black',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 660 * 0.44,
        },
    },
    textTuto4: {
        text: 'textTuto4',
        config: {
            size: '12px',
            fontFamily: 'Montserrat, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: 'Black',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 660 * 0.44,
        },
    },
    textTuto5: {
        text: 'textTuto5',
        config: {
            size: '12px',
            fontFamily: 'Montserrat, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: 'Black',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 660 * 0.44,
        },
    },
    // Quiz
    btnValiderQuiz: {
        text: 'btnValiderQuiz',
    },
    btnSuivantQuiz: {
        text: 'btnSuivantQuiz',
    },
    quizBtn: {
        text: 'quizBtn',
        config: {
            size: '30px',
            fontFamily: 'DMSansBold',
            align: 'center',
            color: 'White',
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 1920,
        },
    },
    // textEnd: {
    //     text: 'Tu as perdu, tu peux rejouer\u00a0!',
    //     config: {
    //         size: '100px',
    //         fontFamily: 'MontserratBold',
    //         align: 'center',
    //         color: 'Black',
    //         backColor: 'transparent',
    //         origin: { x: 0.5, y: 0.5 },
    //         width: 1920,
    //     },
    // },
    // btnEndWin: {
    //     text: 'Recommencer',
    //     config: {
    //         size: '30px',
    //         fontFamily: 'DMSansBold',
    //         align: 'center',
    //         color: 'Black',
    //         backColor: 'transparent',
    //         origin: { x: 0.5, y: 0.5 },
    //         width: 1920,
    //     },
    // },
    // textEndWin: {
    //     text: 'Tu as gané, tu peux rejouer\u00a0!',
    //     config: {
    //         size: '8px',
    //         fontFamily: 'MontserratBold',
    //         align: 'center',
    //         color: 'Black',
    //         backColor: 'transparent',
    //         origin: { x: 0.5, y: 0.5 },
    //         width: 1920,
    //     },
    // },

    endTitleWin: {
        text: 'endTitleWin',
        config: {
            size: `${48 * scaleX}px`,
            fontFamily:
                'MontserratBold, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: Colors.Text.DarkBlue,
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 580,
        },
    },
    endTitleLoose: {
        text: 'endTitleLoose',
        config: {
            size: `${48 * scaleX}px`,
            fontFamily:
                'MontserratBold, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'center',
            color: Colors.Text.DarkBlue,
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 580,
        },
    },
    tim: {
        config: {
            size: `${36 * scaleX}px`,
            fontFamily: 'WWF',
            align: 'center',
            color: Colors.Text.DarkBlue,
            backColor: 'transparent',
            origin: { x: 0.5, y: 0.5 },
            width: 800,
        },
    },
    goodAnswer: 'goodAnswer',
    wrongAnswer: 'wrongAnswer',
    quest: {
        config: {
            size: `${56 * scaleX}px`,
            fontFamily:
                'MontserratItalic, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
            align: 'left',
            color: 'White',
            backColor: 'transparent',
            origin: { x: 0, y: 0 },
            width: 700 * scaleX,
        },
    },
};

export const QuizContents = [
    {
        question: 'question1',
        index: 1,
        isUnique: true,
        answers: [
            { text: 'reponse1_2', isTrue: false },
            { text: 'reponse1_1', isTrue: true },
            { text: 'reponse1_3', isTrue: false },
            { text: 'reponse1_4', isTrue: false },
        ],
        correction: 'feedback1',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question2',
        index: 2,
        isUnique: true,
        answers: [
            {
                text: 'reponse2_1',
                isTrue: true,
            },
            {
                text: 'reponse2_2',
                isTrue: false,
            },
        ],
        correction: 'feedback2',
        isLarge: true,
        isMixed: false,
    },
    {
        question: 'question3',
        index: 3,
        isUnique: true,
        answers: [
            {
                text: 'reponse3_1',
                isTrue: true,
            },
            {
                text: 'reponse3_2',
                isTrue: false,
            },
            {
                text: 'reponse3_3',
                isTrue: false,
            },
            {
                text: 'reponse3_4',
                isTrue: false,
            },
        ],
        correction: 'feedback3',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question4',
        index: 4,
        isUnique: true,
        answers: [
            {
                text: 'reponse4_2',
                isTrue: false,
            },
            {
                text: 'reponse4_1',
                isTrue: true,
            },
        ],
        correction: 'feedback4',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question5',
        index: 5,
        isUnique: true,
        answers: [
            {
                text: 'reponse5_1',
                isTrue: true,
            },
            {
                text: 'reponse5_2',
                isTrue: false,
            },
        ],
        correction: 'feedback5',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question6',
        index: 6,
        isUnique: true,
        answers: [
            {
                text: 'reponse6_2',
                isTrue: false,
            },
            {
                text: 'reponse6_3',
                isTrue: false,
            },
            {
                text: 'reponse6_1',
                isTrue: true,
            },
            {
                text: 'reponse6_4',
                isTrue: false,
            },
        ],
        correction: 'feedback6',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question7',
        index: 7,
        isUnique: true,
        answers: [
            {
                text: 'reponse7_2',
                isTrue: false,
            },
            {
                text: 'reponse7_3',
                isTrue: false,
            },
            {
                text: 'reponse7_4',
                isTrue: false,
            },
            {
                text: 'reponse7_1',
                isTrue: true,
            },
        ],
        correction: 'feedback7',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question8',
        index: 8,
        isUnique: true,
        answers: [
            {
                text: 'reponse8_4',
                isTrue: false,
            },
            {
                text: 'reponse8_2',
                isTrue: false,
            },
            {
                text: 'reponse8_3',
                isTrue: false,
            },
            {
                text: 'reponse8_1',
                isTrue: true,
            },
        ],
        correction: 'feedback8',
        isLarge: true,
        isMixed: false,
    },
    {
        question: 'question9',
        index: 9,
        isUnique: true,
        answers: [
            {
                text: 'reponse9_1',
                isTrue: true,
            },
            {
                text: 'reponse9_2',
                isTrue: false,
            },
            {
                text: 'reponse9_3',
                isTrue: false,
            },
        ],
        correction: 'feedback9',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question10',
        index: 10,
        isUnique: true,
        answers: [
            {
                text: 'reponse10_1',
                isTrue: true,
            },
            {
                text: 'reponse10_2',
                isTrue: false,
            },
            {
                text: 'reponse10_3',
                isTrue: false,
            },
        ],
        correction: 'feedback10',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question11',
        index: 11,
        isUnique: true,
        answers: [
            {
                text: 'reponse11_1',
                isTrue: true,
            },
            {
                text: 'reponse11_2',
                isTrue: false,
            },
            {
                text: 'reponse11_3',
                isTrue: false,
            },
        ],
        correction: 'feedback11',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question12',
        index: 12,
        isUnique: true,
        answers: [
            {
                text: 'reponse12_1',
                isTrue: true,
            },
            {
                text: 'reponse12_2',
                isTrue: false,
            },
            {
                text: 'reponse12_3',
                isTrue: false,
            },
        ],
        correction: 'feedback12',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question13',
        index: 13,
        isUnique: true,
        answers: [
            {
                text: 'reponse13_1',
                isTrue: true,
            },
            {
                text: 'reponse13_2',
                isTrue: false,
            },
            {
                text: 'reponse13_3',
                isTrue: false,
            },
        ],
        correction: 'feedback13',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question14',
        index: 14,
        isUnique: true,
        answers: [
            {
                text: 'reponse14_1',
                isTrue: true,
            },
            {
                text: 'reponse14_2',
                isTrue: false,
            },
            {
                text: 'reponse14_3',
                isTrue: false,
            },
        ],
        correction: 'feedback14',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question15',
        index: 15,
        isUnique: true,
        answers: [
            {
                text: 'reponse15_1',
                isTrue: true,
            },
            {
                text: 'reponse15_2',
                isTrue: false,
            },
            {
                text: 'reponse15_3',
                isTrue: false,
            },
        ],
        correction: 'feedback15',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question16',
        index: 16,
        isUnique: true,
        answers: [
            {
                text: 'reponse16_1',
                isTrue: true,
            },
            {
                text: 'reponse16_2',
                isTrue: false,
            },
            {
                text: 'reponse16_3',
                isTrue: false,
            },
        ],
        correction: 'feedback16',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question17',
        index: 17,
        isUnique: true,
        answers: [
            {
                text: 'reponse17_1',
                isTrue: true,
            },
            {
                text: 'reponse17_2',
                isTrue: false,
            },
            {
                text: 'reponse17_3',
                isTrue: false,
            },
        ],
        correction: 'feedback17',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question18',
        index: 18,
        isUnique: true,
        answers: [
            {
                text: 'reponse18_1',
                isTrue: true,
            },
            {
                text: 'reponse18_2',
                isTrue: false,
            },
            {
                text: 'reponse18_3',
                isTrue: false,
            },
        ],
        correction: 'feedback18',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question19',
        index: 19,
        isUnique: true,
        answers: [
            {
                text: 'reponse19_1',
                isTrue: true,
            },
            {
                text: 'reponse19_2',
                isTrue: false,
            },
            {
                text: 'reponse19_3',
                isTrue: false,
            },
        ],
        correction: 'feedback19',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question20',
        index: 20,
        isUnique: true,
        answers: [
            {
                text: 'reponse20_2',
                isTrue: false,
            },
            {
                text: 'reponse20_1',
                isTrue: true,
            },
            {
                text: 'reponse20_3',
                isTrue: false,
            },
        ],
        correction: 'feedback20',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question21',
        index: 21,
        isUnique: true,
        answers: [
            {
                text: 'reponse21_1',
                isTrue: true,
            },
            {
                text: 'reponse21_2',
                isTrue: false,
            },
            {
                text: 'reponse21_3',
                isTrue: false,
            },
        ],
        correction: 'feedback21',
        isLarge: true,
        isMixed: true,
    },
    {
        question: 'question22',
        index: 22,
        isUnique: true,
        answers: [
            {
                text: 'reponse22_1',
                isTrue: true,
            },
            {
                text: 'reponse22_2',
                isTrue: false,
            },
            {
                text: 'reponse22_3',
                isTrue: false,
            },
        ],
        correction: 'feedback22',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question23',
        index: 23,
        isUnique: true,
        answers: [
            {
                text: 'reponse23_1',
                isTrue: true,
            },
            {
                text: 'reponse23_2',
                isTrue: false,
            },
            {
                text: 'reponse23_3',
                isTrue: false,
            },
        ],
        correction: 'feedback23',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question24',
        index: 24,
        isUnique: true,
        answers: [
            {
                text: 'reponse24_1',
                isTrue: true,
            },
            {
                text: 'reponse24_2',
                isTrue: false,
            },
            {
                text: 'reponse24_3',
                isTrue: false,
            },
        ],
        correction: 'feedback24',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question25',
        index: 25,
        isUnique: true,
        answers: [
            {
                text: 'reponse25_3',
                isTrue: false,
            },
            {
                text: 'reponse25_2',
                isTrue: false,
            },
            {
                text: 'reponse25_1',
                isTrue: true,
            },
        ],
        correction: 'feedback25',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question26',
        index: 26,
        isUnique: true,
        answers: [
            {
                text: 'reponse26_1',
                isTrue: true,
            },
            {
                text: 'reponse26_2',
                isTrue: false,
            },
            {
                text: 'reponse26_3',
                isTrue: false,
            },
        ],
        correction: 'feedback26',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question27',
        index: 27,
        isUnique: true,
        answers: [
            {
                text: 'reponse27_1',
                isTrue: true,
            },
            {
                text: 'reponse27_2',
                isTrue: false,
            },
            {
                text: 'reponse27_3',
                isTrue: false,
            },
        ],
        correction: 'feedback27',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question28',
        index: 28,
        isUnique: true,
        answers: [
            {
                text: 'reponse28_1',
                isTrue: true,
            },
            {
                text: 'reponse28_2',
                isTrue: false,
            },
            {
                text: 'reponse28_3',
                isTrue: false,
            },
        ],
        correction: 'feedback28',
        isLarge: false,
        isMixed: true,
    },
    {
        question: 'question29',
        index: 29,
        isUnique: true,
        answers: [
            {
                text: 'reponse29_2',
                isTrue: false,
            },
            {
                text: 'reponse29_1',
                isTrue: true,
            },
            {
                text: 'reponse29_3',
                isTrue: false,
            },
        ],
        correction: 'feedback29',
        isLarge: false,
        isMixed: false,
    },
    {
        question: 'question30',
        index: 30,
        isUnique: true,
        answers: [
            {
                text: 'reponse30_3',
                isTrue: false,
            },
            {
                text: 'reponse30_2',
                isTrue: false,
            },
            {
                text: 'reponse30_1',
                isTrue: true,
            },
        ],
        correction: 'feedback30',
        isLarge: false,
        isMixed: false,
    },
];
